import { render } from "./RechargeSecondaryTitle.vue?vue&type=template&id=33fcd7b9"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "33fcd7b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33fcd7b9', script)) {
    api.reload('33fcd7b9', script)
  }
  
  module.hot.accept("./RechargeSecondaryTitle.vue?vue&type=template&id=33fcd7b9", () => {
    api.rerender('33fcd7b9', render)
  })

}

script.__file = "src/views/services/pageTitles/RechargeSecondaryTitle.vue"

export default script